module.exports = __webpack_public_path__ + "img/cheese-token.223a3e04.svg";